var map = {
	"./RAP_BrisbaneRiverElement-01.png": 720,
	"./email/facebook.png": 835,
	"./email/instagram.png": 561,
	"./email/linkedin.png": 417,
	"./email/uq-logo-alt.png": 45,
	"./email/uq-logo.png": 487,
	"./email/uqres-logo-alt.png": 465,
	"./email/uqres-logo.png": 141,
	"./email/wechat.png": 571,
	"./email/weibo.png": 35,
	"./grumpy.jpg": 760,
	"./test.png": 489,
	"./victor.png": 470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;